import { render } from "./OrderCommentEditor.vue?vue&type=template&id=70c3c63b&scoped=true&ts=true"
import script from "./OrderCommentEditor.vue?vue&type=script&lang=ts"
export * from "./OrderCommentEditor.vue?vue&type=script&lang=ts"

import "./OrderCommentEditor.vue?vue&type=style&index=0&id=70c3c63b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c3c63b"]])

export default __exports__